import { useMutation } from '@tanstack/react-query';
import { transformKeysToCamelCase } from '../../utils/caseTransformers';
import { ApiKeysClient } from '../httpClients/ApiKeysClient';
import {
  CreateApiKeyPayload,
  CreateApiKeyResponse,
} from '../httpClients/ApiKeysClient/api.schema';
import { MUTATION_KEYS } from './consts';

export const useCreateApiKeyMutation = (payload: CreateApiKeyPayload) => {
  return useMutation({
    mutationKey: [MUTATION_KEYS.CREATE_API_KEY],
    mutationFn: async () => {
      const response = await ApiKeysClient.createApiKey(payload);

      return transformKeysToCamelCase<CreateApiKeyResponse>(response);
    },
  });
};
